export function validateDepartment(job_description) {
  if (!job_description) return "select Department";
  return "";
}
